export default {"src":"/_next/static/media/logo-rightride-dark.ca74e035.svg","height":39,"width":173,"blurWidth":0,"blurHeight":0};